<template>
  <div :class="!autoHeight ? 'grid-relative-height' : ''"
       style="position: relative; padding-bottom: 15px; background:#f2f2f2">
    <ag-grid-vue
      style="width: 100%;height: 100%"
      :style="gridStyle"
      class="ag-theme-balham"
      :gridOptions="options"
      v-if="!disabled && loaded"
      :initialState="initialStates"
      :rowData="rowData"
      :getDataPath="getDataPath"
      :getContextMenuItems="contextMenu"
      :allowContextMenuWithControlKey="true"
      @gridReady="onGridReady"
      @selectionChanged="onSelectionChanged"
      @rowDragEnd="onRowDragEnd"
    >
    </ag-grid-vue>
    <div v-if="gridId" style="position:absolute;bottom: -3px;left:5px;">
      <button
        class="btn btn-link btn-xs"
        :title="$localize('base.saveGridState')"
        @click="saveColumnsState">
        <i class="fas fa-save text-secondary"></i>
      </button>
      <button
        v-for="fontsize of fontsizeToSelect"
        :key="fontsize"
        class="btn btn-link btn-xs"
        :title="$localize('base.saveGridState')"
        @click="setGridFontSize(fontsize)"
        :style="`font-size: ${fontsize}px`">
        <i class="fas fa-text text-secondary"></i>
      </button>
      <button
        class="btn btn-link btn-xs"
        :title="$localize('base.copy')"
        @click="copyColumn()">
        <i class="fas fa-copy text-secondary"></i>
      </button>
      <button
        class="btn btn-link btn-xs"
        :title="$localize('base.reload')"
        @click="reload(api)">
        <i class="fas fa-sync text-secondary"></i>
      </button>

    </div>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import Axios from '../api/baseApi';
import toIso from '@/helper/isoDateHelper'

const formatDate = input => {
  const date = new Date(input);
  return toIso(date);
}
const formatFilter = filters => {
  for (let filterKey of Object.keys(filters)) {
    const filter = filters[filterKey]
    if (filter.filterType !== "date")
      continue;

    if (filter.dateFrom) {
      filter.dateFrom = formatDate(filter.dateFrom);
    }
    if (filter.dateTo) {
      filter.dateTo = formatDate(filter.dateTo);
    }
  }
}
export default {
  props: ['options', 'autoHeight',
    'rowData',
    'api', 'contextMenu', 'disabled',
    'delayed', 'autoColumn', 'grid-id', 'gridStyle', 'fullHeight', 'appendRequestBody', 'loadOnStartup'],
  components: {
    AgGridVue
  },
  data() {
    return {
      loadOnStartup_: this.loadOnStartup,
      initialStates: {},
      loaded: false,
      grid: null,
      fontSize: 11,
      statesAvailable: false,
      groupDefaultExpanded: undefined,
      gridSettings: null,
      getDataPath: undefined,
      autoGroupColumnDef: undefined,
      fontsizeToSelect: [12, 15, 18],
      // modules: AllModules,
      defaults: {
        rowSelection: 'single',
        onRowDoubleClicked: this.doubleClicked,
        rowMultiSelectWithClick: true,
        pagination: true,
        sidebar: true,
        // serverSideStoreType: 'partial',
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          cellStyle: () => {
            return {fontSize: `${this.fontSize}px`}
          }
        },
        navigateToNextCell: params => {
          const suggestedNextCell = params.nextCellPosition;

          this.$emit('cellSelectionChange');
          // this is some code
          const KEY_UP = 38; //  'ArrowUp';
          const KEY_DOWN = 40 // 'ArrowDown';

          const noUpOrDownKeyPressed = params.key !== KEY_DOWN && params.key !== KEY_UP;
          if (noUpOrDownKeyPressed) {
            return suggestedNextCell;
          }
          this.grid.api.forEachNode(node => {
            if (node.rowIndex === suggestedNextCell.rowIndex) {
              node.setSelected(true);
            }
          });
          return suggestedNextCell;
        }
      },
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      context: this.contextMenu,
    }
  },
  methods: {
    doubleClicked(row) {
      this.$emit('doubleClicked', row);
    },
    initDefaults() {
      const keys = Object.getOwnPropertyNames(this.defaults);
      for (let k of keys) {
        if (k === "defaultColDef" && this.defaults && this.options && this.defaults[k] && this.options[k]) {
          this.combineValues(this.defaults[k], this.options[k]);
        }
        if (this.options && (this.options[k] === undefined || k === "onRowDoubleClicked")) {
          this.options[k] = this.defaults[k];
        }
      }
      if(this.options.rowModelType === "serverSide" && !this.options.getRowId) {
        this.options.getRowId = this.getRowId;
      }
    },
    combineValues(objSource, objDest) {
      if (!objDest) return;
      for (let key of Object.getOwnPropertyNames(objSource)) {
        if (objDest[key] === undefined)
          objDest[key] = objSource[key];
      }
    },
    getRowId(params) {
      if(!params.data.id) {
        console.warn("getRowId not found a id, please implement the getRowId() callback!");
        return JSON.stringify(params.data);
      }

      return params.data.id;
    },
    setDataSource(url) {
      let self = this;
      const ds = {
        getRows(params) {
          let request = params.request;
          if (self.appendRequestBody)
            request = self.appendRequestBody(params.request);

          if (request.filterModel) {
            formatFilter(request.filterModel);
          }
          Axios.post(url, request)
            .then(response => {
              if (self.options.treeData) {
                params.successCallback(response.data, 1);
              } else {
                self.$emit('sourceUpdated', {items: response.data.items, count: response.data.totalCount})
                params.success({
                  rowData: response.data.items
                });
              }
            })
            .catch(() => {
              if (params.fail)
                params.fail();
            })
        }
      };
      this.grid.api.setGridOption('serverSideDatasource', ds);
    },
    reload(api) {
      if(this.options.rowModelType !== 'serverSide') {
        this.grid.api.refreshCells();
        return;
      }
      if (api === undefined)
        api = this.api;
      if (!this.grid.api.destroyCalled && this.options.rowModelType === 'serverSide') {
        this.setDataSource(api);
      }
    },
    getAllRows() {
      let rowData = [];
      this.grid.api.forEachNode(node => rowData.push(node.data));
      return rowData;
    },
    mapPublicFunctions() {
      this.grid.reload = this.reload;
      this.grid.selectFirstRowAndCell = this.selectFirstRowAndCell;
      this.grid.selectCell = this.selectCell;
      this.grid.getAllRows = this.getAllRows;
      this.grid.savedSettings = this.initialStates;
    },
    setColumnInitialWidht(grid) {
      if (this.initialStates && this.initialStates.columnSizing && this.initialStates.columnSizing.columnSizingModel) {
        const sizing = this.initialStates.columnSizing.columnSizingModel.map(item => {
          return {
            colId: item.colId, width: item.width
          }
        });
        grid.api.applyColumnState({state: sizing});
      }
    },
    async onGridReady(grid) {
      this.grid = grid;
      this.setColumnInitialWidht(grid);
      this.mapPublicFunctions();
      if (this.options.rowModelType === 'serverSide' && this.loadOnStartup_) {
        this.setDataSource(this.api);
      }
      this.$emit('gridReady', this.grid, this.rowData);
      this.$emit('componentReady', this);
    },
    onRowDragEnd(e) {
      this.$emit('rowDragEnd', e);
    },
    onSelectionChanged() {
      if (this.grid)
        this.$emit('selectionChanged', this.grid.api.getSelectedRows())
    },
    selectFirstRowAndCell() {
      this.selectCell(0, 0);
    },
    selectCell(rowIndex, columnIndex) {
      const firstCol = this.grid.columnApi.getAllDisplayedColumns()[columnIndex];
      this.grid.api.ensureColumnVisible(firstCol);
      this.grid.api.setFocusedCell(rowIndex, firstCol);
    },
    async fetchGridSettings() {
      return await this.$store.dispatch('userSetting/fetch', {id: this.gridId + "-states", device: 'browser'});
    },
    async fetchFontSize() {
      return await this.$store.dispatch('userSetting/fetch', {id: "grid-font-size", device: 'browser'});
    },
    applyFilters(filters) {
      this.grid.api.setFilterModel(filters);
    },
    async saveColumnsState() {
      if (this.gridId) {
        let existingSettings = await this.fetchGridSettings();
        if (!existingSettings || !existingSettings.states)
          existingSettings = {states: {}, filter: {}};

        existingSettings.states = this.grid.api.getState();
        existingSettings.version = '1.1';

        const data = JSON.stringify(existingSettings);
        await this.$store.dispatch('userSetting/addOrUpdate', {
          id: this.gridId + "-states",
          device: 'browser',
          data
        });
        await this.$store.dispatch('NOTIFY_MSG', 'base.notifications.savedGridState', {root: true});
      }
    },
    async saveFilterModel() {
      if (this.gridId) {
        let existingSettings = await this.fetchGridSettings();
        if (!existingSettings)
          existingSettings = {states: {}, filter: {}};

        await this.$store.dispatch('userSetting/addOrUpdate', {
          id: this.gridId + "-states",
          device: 'browser',
          data: JSON.stringify(existingSettings)
        });
        await this.$store.dispatch('NOTIFY_MSG', 'base.notifications.savedGridState', {root: true});
      }
    },
    async setGridFontSize(fontSize) {
      this.fontSize = fontSize;
      await this.$store.dispatch('userSetting/addOrUpdate', {
        id: "grid-font-size",
        device: 'browser',
        data: fontSize
      });
      this.loaded = false;
      this.initDefaults();
      setTimeout(() => this.loaded = true, 250);
    },
    copyColumn() {
      const focusCell = this.grid.api.getFocusedCell();
      const row = this.grid.api.getDisplayedRowAtIndex(focusCell.rowIndex);
      const colId = focusCell.column.colId;

      if(!focusCell.column.colDef.editable)
        return;

      const cellValue = this.grid.api.getValue(colId, row)

      const updates = []
      this.grid.api.forEachNodeAfterFilter(node => {
        const data = node.data;
        updates.push(data);
        node.setDataValue(colId, cellValue);
      });

      // this.grid.api.applyTransaction({update: updates});
    }
  },
  async beforeMount() {
    if (this.loadOnStartup_ === undefined)
      this.loadOnStartup_ = true;

    if (this.autoHeight === true)
      this.options.domLayout = 'autoHeight';

    this.initDefaults();
    this.fontSize = await this.fetchFontSize();
  },
  async mounted() {
    if (this.gridId) {
      const gridSettings = await this.fetchGridSettings();
      if (gridSettings && gridSettings.version === "1.1")
        this.initialStates = gridSettings.states;
    }
    if (this.delayed) {
      setTimeout(() => {
        this.loaded = true;
      }, 100);
    } else {
      this.loaded = true;
    }
  },
  watch: {
    rowData: {
      deep: true,
      handler(v) {
        if (this.grid !== null && this.grid.api !== undefined) {
          // this.grid.api.updateRowData(v);
          this.grid.api.setGridOption('rowData', v);
        }
      }
    }
  }
}
</script>

<style scoped>
.grid-relative-height {
  height: 100%;
}
</style>
